import React from 'react';
import { Checkbox } from '../../../../Forms';
export var BooleanField = function BooleanField(_ref) {
  var field = _ref.field,
    value = _ref.value,
    onChange = _ref.onChange;
  return React.createElement("div", null, React.createElement(Checkbox, {
    id: "checkbox-".concat(field.field),
    name: "checkbox-".concat(field.field),
    value: "checked",
    handleChange: function handleChange() {
      var newValue = !value;
      onChange(newValue);
    },
    checked: value
  }, 'Sí'));
};